import { render, staticRenderFns } from "./inf-intra-vo.vue?vue&type=template&id=03c018dc&scoped=true"
import script from "./inf-intra-vo.vue?vue&type=script&lang=js"
export * from "./inf-intra-vo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c018dc",
  null
  
)

export default component.exports